module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row\"> <div class=\"col-md-3\"> <div class=\"carrier-img ")
    ; __append(escapeFn( locals.type ))
    ; __append("\"></div> <div class=\"buttons\"> <button class=\"edit btn btn-xs btn-block btn-blue\">Edit</button> <button class=\"delete btn btn-xs btn-block btn-red\">Delete</button> </div> </div> <div class=\"col-md-9\"> <div class=\"label-group\"> <label>Description</label> <p>")
    ; __append(escapeFn( locals.description ))
    ; __append("</p> </div> <div class=\"label-group\"> <label>Account ID</label> <p>")
    ; __append(escapeFn( locals.id ))
    ; __append("</p> </div> ")
    ;  if (locals.reference) { 
    ; __append(" <div class=\"label-group\"> <label>Reference</label> <p>")
    ; __append(escapeFn( locals.reference ))
    ; __append("</p> </div> ")
    ;  } 
    ; __append(" </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/carrier_account_list_item.ejs
// module id = 874
// module chunks = 1